<template>
  <div class="employment">
    <common-layout>
      <div slot="header">
        <h3>担保机构简介</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-button @click="addDataNew" type="primary" v-if="isWarrant">新增</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <el-select
            v-model="approvalStatus"
            placeholder="请选择审核状态"
            clearable
            style="display: block;width: 200px;"
            @change="searchSelect"
          >
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="3"></el-option>
            <el-option label="通过" :value="4"></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column label="机构名称" align="center" prop="orgName"></el-table-column>
            <el-table-column label="logo" align="center" prop="logoSrc" min-width="100">
              <template slot-scope="{ row }">
                <el-image fit="contain" style="width: 100px; height: 100px" :src="row.logoSrc" />
              </template>
            </el-table-column>
            <el-table-column
              label="机构简称"
              align="center"
              prop="orgAbbreviation"
            ></el-table-column>
            <el-table-column
              label="成立时间"
              align="center"
              prop="orgEstablishmentDate"
            ></el-table-column>
            <el-table-column label="机构类型" align="center" prop="orgTypeName"></el-table-column>
            <el-table-column
              label="投资阶段"
              align="center"
              prop="investmentStageName"
            ></el-table-column>
            <el-table-column label="机构地址" align="center" prop="orgAbbreviation">
              <template slot-scope="{ row }">
                <div>{{ row.orgProvince }} {{ row.orgCity }} {{ row.orgDistrict }}</div>
              </template>
            </el-table-column>

            <el-table-column label="联系人" align="center" prop="contactPerson"></el-table-column>
            <el-table-column label="联系方式" align="center" prop="contactInfo"></el-table-column>
            <el-table-column label="是否发布" align="center" prop="publishedFlag">
              <template slot-scope="{ row }">
                <div v-if="row.publishedFlag === 0">未发布</div>
                <div v-if="row.publishedFlag === 1">已发布</div>
              </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center" prop="approvalStatus">
              <template slot-scope="{ row }">
                <div v-if="row.approvalStatus === 1">待审核</div>
                <div v-if="row.approvalStatus === 2">不通过</div>
                <div v-if="row.approvalStatus === 3">退回</div>
                <div v-if="row.approvalStatus === 4">通过</div>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  v-if="(scope.row.approvalStatus === 1 || scope.row.approvalStatus === 3) && isWarrant"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDetail(scope.$index, scope.row)"
                >
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :disabled="dialogType === 'detail'"
        :rules="rules"
        label-width="120px"
      >
        <el-row>
          <el-row>
            <el-form-item label="机构名称" prop="orgName">
              <el-input v-model="ruleForm.orgName" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简称" prop="orgAbbreviation">
              <el-input v-model="ruleForm.orgAbbreviation" placeholder="请输入机构简称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="成立时间" prop="orgEstablishmentDate">
              <el-date-picker
                style="width: 100%"
                v-model="ruleForm.orgEstablishmentDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构地址" prop="orgProvince">
              <!-- 三联 -->
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected"
                :province="ruleForm.orgProvince"
                :city="ruleForm.orgCity"
                :disabled="dialogType === 'detail'"
                :area="ruleForm.orgDistrict"
              ></v-distpicker>
            </el-form-item>
            <el-form-item prop="orgAddress">
              <el-input v-model="ruleForm.orgAddress" placeholder="请填写详细地址"></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="机构性质" prop="orgType">
              <el-select
                style="width: 100%"
                v-model="ruleForm.orgType"
                @change="orgChange"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in orgTypeList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-form-item label="机构简介" prop="orgDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入简介"
                v-model="ruleForm.orgDescription"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="contactInfo">
              <el-input v-model="ruleForm.contactInfo" placeholder="请输入联系方式"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="logo" prop="logoSrc">
              <!-- <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
              >

                <img v-if="ruleForm.logoSrc" :src="ruleForm.logoSrc" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logoSrc }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logoSrc">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logoSrc">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span> -->

              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="logoSrc"
                :before-upload="beforeAvatarUpload"
                :limit="limit"
                ref="upload0"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'logoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="dialogType !== 'detail'"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'logoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="发布" prop="publishedFlag">
              <el-switch
                v-model="ruleForm.publishedFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-row>
          <el-form-item
            label="审批状态"
            prop="approvalStatus"
            style="text-align:left"
            v-if="dialogType === 'detail'"
          >
            <el-select
              v-model="ruleForm.approvalStatus"
              placeholder="请选择审核状态"
              style="display: block;"
            >
              <el-option label="待审核" :value="1"></el-option>
              <el-option label="不通过" :value="2"></el-option>
              <el-option label="退回" :value="3"></el-option>
              <el-option label="通过" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="dialogType === 'add'">
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="updateSubmitForm('ruleForm')"
          v-show="dialogType === 'edit'"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :append-to-body="true" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../../components/common-layout.vue';

export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      logoSrc: [],
      dialogImageUrl: '',
      showUpload: false,
      approvalStatus: '',
      formApprovalStatus: '',
      accessoryMaterialsSrc: [],
      areaList: [],
      orgTypeList: [],
      dialogType: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10,
        dataType: 3
      },
      queryId: '',
      deleteRow: [],
      rencaiList: [],
      jishuList: [],
      total: 10,
      limit: 1,
      Title: '',
      searchValue: '',
      dialogFormVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        dataType: 3,
        orgName: '',
        orgAbbreviation: '',
        orgEstablishmentDate: '',
        orgProvince: '',
        orgCity: '',
        orgDistrict: '',
        orgAddress: '',
        orgType: '',
        orgTypeName: '',
        orgDescription: '',
        contactInfo: '',
        logoSrc: '',
        publishedFlag: 0,
        approvalStatus: 1
      },
      rules: {
        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: 'change' }],
        orgProvince: [{ required: true, message: '请选择机构地址', trigger: 'change' }],
        orgCity: [{ required: true, message: '请选择机构地址-市', trigger: 'change' }],
        orgDistrict: [{ required: true, message: '请选择机构地址-区', trigger: 'change' }],
        orgDescription: [{ required: true, message: '请输入机构简介', trigger: 'blur' }],
        orgName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        orgEstablishmentDate: [{ required: true, message: '请选择成立时间', trigger: 'change' }],
        orgAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        orgType: [{ required: true, message: '请选择机构性质', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        logoSrc: [{ required: true, message: '请上传logo', trigger: 'changer' }],
        orgAbbreviation: [{ required: true, message: '请输入机构简称', trigger: 'blur' }],
        approvalStatus: [{ required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }]
      }
    };
  },
  created() {
    console.log(' this.$store.getters.userInfo.type');
    this.getData();
    this.getSiftList('financial_institution_category');
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    }
  },
  methods: {
    checkLimit(filelist, index) {
      const limit = this.limit;
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this.showUpload = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this.showUpload = false;
      }
    },
    open() {
      if (this.dialogType === 'add') {
        this.ruleForm = {
          dataType: 3,
          orgName: '',
          orgAbbreviation: '',
          orgEstablishmentDate: '',
          orgProvince: '',
          orgCity: '',
          orgDistrict: '',
          orgAddress: '',
          orgType: '',
          orgTypeName: '',
          orgDescription: '',
          contactInfo: '',
          logoSrc: '',
          publishedFlag: 0,
          approvalStatus: 1
        };
        this.logoSrc = []
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        this.getDetail();
      }
    },

    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;
          this.logoSrc = JSON.parse(res.data.logoSrc)
        } else {
          this.ruleForm = {
            dataType: 3,
            orgName: '',
            orgAbbreviation: '',
            orgEstablishmentDate: '',
            orgProvince: '',
            orgCity: '',
            orgDistrict: '',
            orgAddress: '',
            orgType: '',
            orgTypeName: '',
            orgDescription: '',
            contactInfo: '',
            logoSrc: '',
            publishedFlag: 0,
            approvalStatus: 1
          };
        }
      } catch (e) {
        console.log(e);
      }
    },
    orgChange(id) {
      const data = this.orgTypeList.find(item => item.id === id);
      this.ruleForm.orgTypeName = data.label;
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.ruleForm.logoSrc = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    // 人才类别和从事技术领域
    getSiftList(type) {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: [type]
        })
        .then(res => {
          if (res.code === 0) {
            const { financial_institution_category } = res.data;
            this.orgTypeList = [...financial_institution_category];
            const model = this.orgTypeList.find(item => item.label === '担保机构');
            if (model) {
              this.ruleForm.orgType = model.id;
              this.ruleForm.orgTypeName = model.label;
            }
          }
        });
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        console.log('  this.ruleForm[type]', this.ruleForm[type]);
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return type && isLt2M;
    },
    getData() {
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/finance/investment-firms/page',
          this.listQuery
        )
        .then(res => {
          if (res.code == 0) {
            let arr = res.data.data;
            arr.forEach(item => {
              if (item.logoSrc) {
                item.logoSrc = JSON.parse(item.logoSrc)[0].url;
              } else {
                item.logoSrc = '';
              }
            });

            console.log('数组', arr);
            this.tableData = arr;
            this.total = res.data.total;
          }
        });
    },

    handleDownload(file) {
      console.log('handleDownload', file);
      if (file.url) {
        const url = file.url;
        DownLoadUrl(url);
      }
    },
    searchSelect(e) {
      if (e) {
        this.listQuery.approvalStatus = e;
        this.getData();
      } else {
        this.$delete(this.listQuery, 'approvalStatus');
        this.getData();
      }
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow.length) {
        this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.http
              .request(
                this.urlConfig.devUrl + 'apij2/admin-api/finance/investment-firms/delete',
                {
                  ids: this.deleteRow
                },
                'delete'
              )
              .then(res => {
                if (res.code == 0) {
                  this.listQuery.page = 1;
                  this.getData();
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                } else {
                  this.$message({
                    message: '失败！',
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的记录'
        });
      }
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '详情';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
    },
    //城市选择
    citySelected(e) {
      console.log(e, 'e');
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    //删除
    handleDelete(index, row) {
      const data = [row.id];
      this.$confirm('此操作将批量删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .request(
              this.urlConfig.devUrl +
                '/apij2/admin-api/voucher/resource-technical-personnel/delete',
              {
                ids: data
              },
              'delete'
            )
            .then(res => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    // 人才
    changeTalent(id) {
      console.log('id');
      const data = this.rencaiList.find(item => item.id == id);
      this.ruleForm.talentCategoryName = data.label;
    },
    // 技术领域
    changeTechFieldId(id) {
      const data = this.jishuList.find(item => item.id == id);
      this.ruleForm.techFieldName = data.label;
    },
    addData() {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/create`, {
          ...this.ruleForm,
          dataType: 3
        })
        .then(res => {
          if (res.code === 0) {
            this.getData();
            this.dialogFormVisible = false;
            this.$message.success('新增成功');
          } else {
            this.$messgae.error('新增失败');
          }
        })
        .catch(e => {
          this.$messgae.error('新增失败');
        });
    },
    editData() {
      // 审核-退回的担保机构，修改重置为待审核
      if (this.ruleForm.approvalStatus === 3) {
        this.ruleForm.approvalStatus = 1;
      }

      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/update`, {
          ...this.ruleForm,
          dataType: 3
        })
        .then(res => {
          if (res.code === 0) {
            this.getData();
            this.dialogFormVisible = false;
            this.$message.success('编辑成功');
          } else {
            this.$messgae.error('编辑失败');
          }
        })
        .catch(e => {
          this.$messgae.error('编辑失败');
        });
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 新增提交
          this.addData();
        } else {
          console.log('this.ruleForm', this.ruleForm);
          return false;
        }
      });
    },
    updateSubmitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑提交
          this.editData();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.employment {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}

.warrantDialog {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .upload-demo {
  margin-top: 10px;
  /deep/.el-upload {
    /deep/.el-button {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(66, 141, 255, 1);
      border-radius: 18px;
      padding: 10px 25px;
    }
  }
}
</style>
